import React from 'react';
/**
 * Vertical spacer and a drop target. Calculates spacing to use depending on the first and last flags.
 *
 * @param {object} props - The component props.
 * @param {string} props.editorPath - Value for the `data-editor-path` attribute, used for identifying the element in the editor.
 * @param {React.ReactNode} [props.placeholderElement] - Optional element shown to indicate the drop target area to the user.
 * @param {number} props.spacing - The spacing (in pixels) between components. Should be an even number so the drop target is centered.
 * @param {boolean} props.first - Whether this spacer is the first in the list. Affects padding calculation.
 * @param {boolean} props.last - Whether this spacer is the last in the list. Affects padding calculation.
 * @returns {JSX.Element} The rendered spacer/drop target element.
 */
export const DropTargetSpacerVertical = (props) => {
    let rootPaddingLeft = props.spacing / 2;
    let rootPaddingRight = props.spacing / 2;
    let containerPaddingLeft = props.spacing / 2;
    let containerPaddingRight = props.spacing / 2;
    let placeholderPaddingLeft = props.spacing / 2;
    let placeholderPaddingRight = props.spacing / 2;
    if (props.first && props.last) {
        rootPaddingLeft = 0;
        rootPaddingRight = 0;
        containerPaddingLeft = 0;
        containerPaddingRight = 0;
        placeholderPaddingLeft = 0;
        placeholderPaddingRight = 0;
    }
    else if (props.first) {
        rootPaddingLeft = 0;
        rootPaddingRight = 0;
        containerPaddingLeft = 0;
        containerPaddingRight = props.spacing;
        placeholderPaddingLeft = 0;
        placeholderPaddingRight = props.spacing;
    }
    else if (props.last) {
        rootPaddingLeft = 0;
        rootPaddingRight = 0;
        containerPaddingLeft = props.spacing;
        containerPaddingRight = 0;
        placeholderPaddingLeft = props.spacing;
        placeholderPaddingRight = 0;
    }
    return (React.createElement("div", { "data-drag-target": true, "data-editor-path": props.editorPath, style: { paddingLeft: rootPaddingLeft, paddingRight: rootPaddingRight } },
        React.createElement("div", { "data-drag-target-container": true, style: { display: 'none', paddingLeft: containerPaddingLeft, paddingRight: containerPaddingRight } }),
        props.placeholderElement != null && (React.createElement("div", { "data-drag-target-placeholder": true, style: { display: 'block', paddingLeft: placeholderPaddingLeft, paddingRight: placeholderPaddingRight } }, props.placeholderElement))));
};
